import BackofficeDocuments from './Backoffice';
import BrokerDocuments from './Broker';

const Documents = ({ portfolioUuid, profileUuid, backOfficeUser }) => {
  if (backOfficeUser) {
    return <BackofficeDocuments portfolioUuid={portfolioUuid} profileUuid={profileUuid} />;
  }
  return <BrokerDocuments portfolioUuid={portfolioUuid} profileUuid={profileUuid} />;
};

export default Documents;
